export default __webpack_public_path__ + "static/connect-332a6031b8508eb8b84f7e8af77f6589.mp4";